"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_shared_ts_1 = require("firefly-shared-ts");
var browser_1 = require("../helpers/browser");
var event_1 = require("../helpers/event");
var identity_1 = require("../helpers/identity");
var GlobalDataLayerInterceptor = /** @class */ (function () {
    function GlobalDataLayerInterceptor() {
    }
    GlobalDataLayerInterceptor.prototype.apply = function (json, persistMethod) {
        var cookieDisabled = firefly_shared_ts_1.Browser.isCookiesDisabled();
        var isNew = (0, identity_1.isNewGuest)();
        var orientation = firefly_shared_ts_1.Browser.getScreenOrientation();
        var os = firefly_shared_ts_1.Browser.getOperatingSystem();
        var preferredLanguage = firefly_shared_ts_1.Browser.getPreferredLanguage();
        var primaryDomain = firefly_shared_ts_1.Browser.getDomain();
        var referrer = (0, browser_1.getReferrer)(persistMethod);
        var screenColorDepth = firefly_shared_ts_1.Browser.getScreenColorDepth();
        var screenSize = { height: firefly_shared_ts_1.Browser.getScreenHeight(), width: firefly_shared_ts_1.Browser.getScreenWidth() };
        var sessionId = (0, identity_1.getSessionId)(persistMethod);
        var size = { height: firefly_shared_ts_1.Browser.getBrowserHeight(), width: firefly_shared_ts_1.Browser.getBrowserWidth() };
        var subDomain = firefly_shared_ts_1.Browser.getSubdomain();
        var type = firefly_shared_ts_1.Browser.getDeviceType();
        var url = (0, browser_1.sanitizeUrl)(firefly_shared_ts_1.Browser.getCurrentUrl());
        var userAgent = firefly_shared_ts_1.Browser.getName();
        var viewId = (0, event_1.getViewId)(persistMethod);
        var fireflyId = (0, identity_1.getVisitorId)();
        var oldInterceptorJSON = {
            appState: { referrer: referrer, screenOrientation: orientation, url: url, viewId: viewId, windowSize: firefly_shared_ts_1.Browser.getBrowserSize() },
            guest: { browser: userAgent, cookieDisabled: cookieDisabled, deviceType: type, newVisitor: isNew, os: os, preferredLanguage: preferredLanguage, primaryDomain: primaryDomain, screenColorDepth: screenColorDepth, screenSize: firefly_shared_ts_1.Browser.getScreenSize(), session: sessionId, subDomain: subDomain, visitorId: fireflyId }
        };
        var newInterceptorJSON = {
            browser: { cookieDisabled: cookieDisabled, orientation: orientation, preferredLanguage: preferredLanguage, primaryDomain: primaryDomain, referrer: referrer, size: size, subDomain: subDomain, url: url, userAgent: userAgent },
            device: { os: os, screenColorDepth: screenColorDepth, screenSize: screenSize, type: type },
            identity: { fireflyId: fireflyId, isNew: isNew, sessionId: sessionId },
            view: { id: viewId }
        };
        var interceptorJSON = firefly_utilities_ts_1.Utilities.extend(oldInterceptorJSON, newInterceptorJSON);
        return firefly_utilities_ts_1.Utilities.extend(json, interceptorJSON);
    };
    return GlobalDataLayerInterceptor;
}());
exports.default = GlobalDataLayerInterceptor;
